<template lang="pug">
  v-tooltip.tooltip-tc(v-model="tooltip" bottom ref="markList")
    template(v-slot:activator="{ on }")
      v-chip.chip(
          v-on="($vuetify.breakpoint.smAndDown ? tooltip: true) && !!$slots.tooltip && $slots.default[0].text.length >= 4 && on"
          :class="[ isLastChip ? 'last-chip': '', tooltip ? 'select-style' : 'base-style']"
          @click="changeTooltip()"
          @blur="hiddenTooltip()" tabindex="0"
          )
        slot
        font-awesome-icon.icon-style(@click="clear" :icon="['fas', 'times']")
    span(v-if="!!$slots.tooltip && $slots.default[0].text.length >= 4"
        )
      .text-center
        slot(name="tooltip")

</template>
<script>
export default {
  name: 'TagChip',
  props: {
    isLastChip: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      tooltip: false,
      focused: false
    }
  },
    mounted: async function () {
        window.addEventListener("scroll", this.hiddenTooltip, { passive: true });
    },
  methods: {
    clear () {
      this.$emit('onClear')
    },
    changeTooltip () {
        if(this.$vuetify.breakpoint.smAndDown) {
            this.tooltip = !this.tooltip
        }
    },
    hiddenTooltip () {
      this.tooltip = false
    }
  }
}
</script>
<style scoped lang="sass">
  @import "scss/variables.scss"
  @import "scss/colors.scss"

  @media (max-width: $xsOnly)
    .tooltip-tc
      max-width: 100px

  @media (min-width: $smAndUp)
    .tooltip-tc
      max-width: 500px

  .chip.chip.chip
    margin: 4px 8px 4px 0
    background-color: $chipFile

  .last-chip
    margin: 4px 0 4px 0 !important

  .icon-style
    font-size: 20px
    color: $greyText

  .v-chip::before
    opacity: 0 !important

  .select-style
    color: $lightGrey !important

  .base-style
    background: $chipFile !important

</style>
